import { authenticatedApiRequest } from "./core";
import type { PaginatedResponse } from "./core";
import type { Account } from "@/types";

export interface ChartOfAccountsResponse extends PaginatedResponse {
  results: Account[];
}

export const accountsApi = {
  getChartOfAccounts: async (labelId: string): Promise<ChartOfAccountsResponse> => {
    return authenticatedApiRequest<ChartOfAccountsResponse>(
      `/ledger/labels/${labelId}/chart-of-accounts`,
    );
  },
};
